/**
 * in this module there are all the related functions for:
 *  - initialize the date and the datepicker
 *  - initialize the layer
 *  - add the layer to the map
 *  - create the hidden list of visible accidents
 */

/**
 * import modules
 */
import TileLayer from 'ol/layer/Tile'
import TileWMS from 'ol/source/TileWMS'
import TileGrid from 'ol/tilegrid/TileGrid'
import {fromCircle} from 'ol/geom/Polygon'
import functions from '../common/functions'
import map from '../common/map'
import drawing from '../common/drawing'
import overlay from '../common/overlay'
import amextras from './amextras_plus'
/**
 * global vars used
 *  - in the layer
 *  - in the datepicker
 */

let amfeatlayer
let dFromDate
let dToDate
let polyfilt
var pageconfig = JSON.parse($('#pageconfig').val())

/**
 * initialize the date
 */

const initDate = () => {

  //check for accident layers otherwise return
  if (functions.getLayerList('accsmap') === '') {return}
  /**
   * initialize the twsettings
   */


  /**
   * get the accsto from the settings
   * update the dToDate variable
   * get the accsfrom from the settings
   */
  let tmp = $('.paccsto').text().split('/')
  dToDate = new Date(tmp[2], tmp[1] - 1, tmp[0])

  tmp = $('.paccsfrom').text().split('/')

  /**
   * check if is devon or a normal AM traffweb
   * update the dFromDate accordingly
   */

  if (window.location.href.indexOf('vzsw') !== -1) {
    dFromDate = new Date(new Date(dToDate).setMonth(dToDate.getMonth() - 60))
    dFromDate = new Date(new Date(dFromDate).setDate(dFromDate.getDate() + 1))
    // dFromDate = new Date(new Date(dToDate).setMonth(dToDate.getMonth() - 59));
    dFromDate = new Date($('.paccsfrom').text())
  }
  else {
    dFromDate = new Date(new Date(dToDate).setMonth(dToDate.getMonth() - 36))
    dFromDate = new Date(new Date(dFromDate).setDate(dFromDate.getDate() + 1))
  }

  /**
   * end const initDate = (getSettings) =>
   */
}

/**
 * initialize the datepicker
 */

const initDatePicker = () => {


  //check for accident layers otherwise return
  if (functions.getLayerList('accsmap') === '') {return}


  /**
   * wrap everything inside an onload event listener (IE bug with form)
   */

  document.addEventListener('DOMContentLoaded', () => {
    /**
     * reset the datedisplayForm
     */

    if ($('#datedisplayForm').length > 0) {
      document.getElementById('datedisplayForm').reset()
    }
  })

  /**
   * initialize the dAccFromInp and dAccToInp variable
   */

  let dAccFromInp = functions.leadZero(dFromDate.getDate()) + '/' + (functions.leadZero(dFromDate.getMonth() + 1)) + '/' + dFromDate.getFullYear()
  let dAccToInp = functions.leadZero(dToDate.getDate()) + '/' + (functions.leadZero(dToDate.getMonth() + 1)) + '/' + dToDate.getFullYear()

  /**
   * populate the date in the datepicker, in the header and the modal
   */

  $('#fromdate').val(dAccFromInp)
  $('#todate').val(dAccToInp)
  $('.helppaccsfrom').text($('#fromdate').val())
  $('.helppaccsto').text($('#todate').val())

  /**
   * set the datepicker options
   */

  $('#fromdate').datepicker({
    forceParse: false,
    format: 'dd/mm/yyyy',
    autoclose: true,
    startDate: $('.paccsfrom').text(),
    endDate: $('.paccsto').text(),
    orientation: 'bottom auto'
  }).on('show', function (e) {
    e.stopPropagation()
  })

  $('#todate').datepicker({
    format: 'dd/mm/yyyy',
    autoclose: true,
    startDate: $('.paccsfrom').text(),
    endDate: $('.paccsto').text(),
    orientation: 'bottom auto'
  }).on('show', function (e) {
    e.stopPropagation()
  })

  /**
   * click event listener on the display button
   */

  $('#datedisplay').click(function (e) {
    /**
     * stop propagation and prevent default
     */

    e.preventDefault()
    e.stopPropagation()

    /**
     * populate the date in the datepicker, in the header and the modal
     */
    $('.helppaccsfrom').text($('#fromdate').val())
    $('.helppaccsto').text($('#todate').val())

    /**
     * update the accsmap layer
     * hide the popup
     */

    updateLayerParams()
    overlay.overlay.setPosition(undefined)
    if (functions.mobileTabletView()) {
      $('#dropdownToolsMobile').trigger('click')
    }
  })

  /**
   * simulate a click event on the display button when the ENTER key is pressed inside the input
   */

  $('#fromdate').keypress(function (e) {
    if (e.which === 13) {
      $('#datedisplay').click()
    }
  })

  $('#todate').keypress(function (e) {
    if (e.which === 13) {
      $('#datedisplay').click()
    }
  })

  /**
   * end const initDatePicker = (getSettings) =>
   */
}

/**
 * create the accsmap layer
 */

let initAmLayer = () => {
  /**
   * get the settings from the functions module
   */
  //check for accident layers otherwise return
  if (functions.getLayerList('accsmap') === '') {return}

  /**
   * get resolutions from scale
   */

  // final resolutions array
  const resolutions = []
  // temp scale array
  const scaleArray = []
  // scales array
  const scales = pageconfig.scales.split(',')
  // create a temporary array of scales in number
  functions.getScale(scales, scaleArray)
  // create the final resolutions array
  functions.setResolution(scaleArray, resolutions)

  /**
   * get the extent of the visible map
   */
  /**
  * get the extent of the visible map
   */
  //let layerinfo = pageconfig.layers.find(el => el.layers === "accsmap")
  //this wont work on ie11 so need to use function below

   var layerinfo = functions.altFind(pageconfig.layers, function(e) {
    return e.layers === "accsmap"
  })

   const setExt = pageconfig.bounds.split(',')
   const ext = [parseInt(setExt[0]), parseInt(setExt[1]), parseInt(setExt[2]), parseInt(setExt[3])]

  /**
   * update the date of the data to display
   */
   let dAccFrom = $('#fromdate').val().split('/').reverse().join('-')
   let dAccTo =  $('#todate').val().split('/').reverse().join('-')

  /**
   * set the default date to display the accidents
   */

  // feature layer
  amfeatlayer = new TileLayer({
    // this extent limit the visible map
    name: 'accsmap',
    className: 'featlayer',
    extent: ext,
    // Load low-resolution tiles up to preload levels. By default preload is 0, which means no preloading
    preload: Infinity,
    source: new TileWMS({
      url: layerinfo.wmsfeat,
      params: {
        'LAYERS': functions.getLayerList('accsmap'),
        SEVERITY: $('#rtcfeatclick').val(),
        ACCFROM: dAccFrom,
        PDQ: 'pdq0',
        ACCTO: dAccTo,
        PFILT: '',
        format: 'image/png',
        'TILED': true
      },
      ratio: 1,
      gutter: 40,
      isBaseLayer: false,
      serverType: 'mapserver',
      crossOrigin: 'anonymous',
      projection: 'EPSG:27700',
      tileGrid: new TileGrid({
        resolutions: resolutions,
        extent: ext,
        tileSize: [128, 128]
      })
    })
  })

  /**
   * duplicate the previous event outside of the map.moveend to don't display the message on page reload
   * display the text zoom in to view accidents
   * this can be used for everyone else it just need that div
   */


    if (map.getMap().getView().getResolution() > 140) {
      $('#accsLimit').show()
    }
    else {
      $('#accsLimit').hide()
    }


  /**
   * add a click event listener to the fmarkfil button
   */

  $('#fmarkfil').on('click', function (e) {
    /**
     * run the updateLayerParams with a delay function
     * this is due because it needs to run the previous code
     * or it will not take the correct values
     */
    setTimeout(() => {
      amextras.updateReportParams()
      updateLayerParams()
    }, 300)
  })

  /**
   * add a click event listener to the pdqlist list
   */

  $(document).on('click', '#pdqlist li', function () {
    // hide the popup
    overlay.overlay.setPosition(undefined)

    /**
     * remove the pdq_on class from all the li item
     * add the pdq_on to the correct li item
     */

    $('#pdqlist li').removeClass('pdq_on')
    $(this).addClass('pdq_on')

    /**
     * update the parameters
     */

    updateLayerParams()

    /**
     * check if it's an accsmap plus TW
     * run the updateReportParams function
     */

    if (pageconfig.report) {
      amextras.updateReportParams()
    }

    if (functions.mobileTabletView()) {
      $('#dropdownToolsMobile').trigger('click')
    }
  })

  /**
   * end let initAmLayer = ()
   */
}

/**
 * update the accsmap layer parameters
 */

const updateLayerParams = () => {

  //check for accident layers otherwise return
  if (functions.getLayerList('accsmap') === '') {return}

  /**
   * initialize the  settings
   */

  let pdq = 'pdq0'

  if (pageconfig.pdq) {
    pdq = $('.pdq_on').attr('data-value')
  }

  /**
   * check if it's an accsmap plus TW and the filter button is on
   */

  if (pageconfig.appname.type === 'accsmap' && $('#fmarkfil').val() === 'on') {
    /**
     * initialize the Dsource
     * create the polygon to pass into the parameter
     */

    let Dsource = drawing.getSource()

    const setCharAt = (str, index, chr) => {
      if (index > str.length - 1) return str
      return str.substr(0, index) + chr + str.substr(index + 1)
    }

    let POLYGON = ''

    // check if the draw was a polygon or a circle and get the correct parameter to send in the request
    if (Dsource.getFeatures()[0].getGeometry().getType() === 'Polygon') {
      POLYGON = Dsource.getFeatures()[0].getGeometry().getCoordinates()
    }
    else {
      POLYGON = fromCircle(Dsource.getFeatures()[0].getGeometry()).getCoordinates()
    }

    // convert the array back from the previous function into a string and remove the unseccessary commas
    POLYGON = POLYGON.toString()
    let allComma = []

    for (let i = 0; i < POLYGON.length; i++) {
      if (POLYGON[i] === ',') allComma.push(i)
    }

    for (let i = 0; i < allComma.length; i++) {
      if (i % 2 === 0) {
        POLYGON = setCharAt(POLYGON, allComma[i], ' ')
      }
    }
    polyfilt = `POLYGON((${POLYGON}))`
  }

  /**
   * else if it's a basic accsmap TW
   */

  else {
    let mapBound = pageconfig.bounds.split(',')

    polyfilt = 'POLYGON((' + mapBound[0] + ' ' + mapBound[1] + ',' +
      mapBound[2] + ' ' + mapBound[1] + ',' +
      mapBound[2] + ' ' + mapBound[3] + ',' +
      mapBound[0] + ' ' + mapBound[3] + ',' +
      mapBound[0] + ' ' + mapBound[1] + '))'
    // E.g. "POLYGON((500100 176000(0 1) ,512900 176000(2 1),512900 185800(2 3),500100 185800(0 3),500100 176000(0 1)))";
  }
  $('#pfilt').val(polyfilt)
  /**
   * hide the layer
   */

  amfeatlayer.setVisible(false)

  /**
   * update the restrictions to dipslay
   * update the "from" date
   * update the "to" date
   * update the polyfilt (filter with the drawing)
   * update the pdq (predefined query)
   * refresh the source
   * show the layer
   */

  /**
   * check the severity array
   * apply the correct value
   * this is needed because if you don't pass anything
   * it will display slight accidents because the query in the map is ...in (%severity%)...
   */

  let severity = ''

  let targetDivFeat = ''
  targetDivFeat = 'rtcfeatclick'


  if ($(`#${targetDivFeat}`).val() === ' ') {
    severity = `'none'`
  }
  else {
    severity = $(`#${targetDivFeat}`).val()
  }

  amfeatlayer.getSource().getParams().SEVERITY = severity
  amfeatlayer.getSource().getParams().ACCFROM = $('#fromdate').val().split('/').reverse().join('-')
  amfeatlayer.getSource().getParams().ACCTO = $('#todate').val().split('/').reverse().join('-')
  amfeatlayer.getSource().getParams().PFILT = polyfilt
  amfeatlayer.getSource().getParams().PDQ = pdq
  amfeatlayer.getSource().refresh()
  amfeatlayer.setVisible(true)

  map.getMapTab()

  if (pageconfig.appname.type === 'accsmap' && pageconfig.private) {
    amextras.updateReportParams()
  }

  /**
   * end const updateLayerParams = (getdAccFrom, getdAccTo) =>
   */
}

/**
 * remove the whole accsmap layer
 */

$('#rtclayerSwitch').on('click', function () {
  /**
   * assign this to the variable $this
   */

  let $this = $(this)

  /**
   * hide the popup
   */

  overlay.overlay.setPosition(undefined)

  /**
   * check if the value is on
   * change the value to off
   * remove the check class and apply the times class
   * remove the amfeatlayer
   * hide the accsmap legend
   */

  if ($this.val() === 'on') {
    $this.val('off')
    $this.removeClass('fa-check').addClass('fa-times')
    map.getMap().removeLayer(amfeatlayer)
    $('#rtclegend').hide()
  }

  /**
   * check if the value is off
   * change the value to on
   * remove the times class and apply the check class
   * add the amfeatlayer
   * show the accsmap legend
   */
  else {
    $this.val('on')
    $this.removeClass('fa-times').addClass('fa-check')
    map.getMap().addLayer(amfeatlayer)
    amfeatlayer.setZIndex(3)
    $('#rtclegend').css('display', 'flex')
  }

  /**
   * end $('#rtclayerSwitch').on('click', function () {
   */
})


/**
 * export the layers
 */

const amlayer = () => {
  return amfeatlayer
}

/**
 * export the addlayer
 */

const addlayer = () => {
  //check for accident layers otherwise return
  if (functions.getLayerList('accsmap') === '') {return}

  map.getMap().addLayer(amfeatlayer)
  amfeatlayer.setZIndex(3)
}

/**
 * EXPORT
 */

export default {
  initDate,
  initDatePicker,
  initAmLayer,
  amlayer,
  addlayer,
  updateLayerParams
}
